import { Modal } from "antd";
import { FC, useEffect } from "react";
import { BiDownload } from "react-icons/bi";
import styled from "styled-components";
import { UAParser } from "ua-parser-js";
import config from "../../../../lib/config";
import { useTranslation } from "react-i18next";

const Block = styled.div`
  .button-text {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }

  .button-text > * {
    font-size: 20px;
  }
`;

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  scheme: string;
}

const DownloadProgramModal: FC<IProps> = ({
  visible,
  setVisible,
  scheme,
}) => {
  const parser = new UAParser();
  const os = parser.getOS().name?.toLowerCase();
  const { t } = useTranslation();

  useEffect(() => {
    if (visible && setVisible) {
      setTimeout(() => setVisible(false), 60000);
    }
  }, [visible, setVisible]);

  const getSchemeText = () => {
    switch (scheme) {
      case 'polycanbon':
        return 'CANB ON';
      case 'canbalex':
        return 'CANB Alex';
      default:
        return '';
    }
  };

  const getSchemeUrl = () => {
    switch (scheme) {
      case 'polycanbon':
        return getCanbOnUrl();
      case 'canbalex':
        return getAlexUrl();
      default:
        return '';
    }
  };

  const getCanbOnUrl = () => {
    if (os && (os.indexOf('android') > -1 || os.indexOf('linux') > -1)) {
      return config.canbonAndroidUrl;
    }

    return config.canbonPcUrl;
  }

  const getAlexUrl = () => {
    if (os && (os.indexOf('android') > -1 || os.indexOf('linux') > -1)) {
      return config.alexAndroidUrl;
    }
    if (os && (os.indexOf('iphone') > -1 || os.indexOf('ipad') > -1 || os.indexOf('mac') > -1)) {
      return config.alexIosUrl;
    }

    return config.alexPcUrl;
  }

  return (
    <>
      <Modal
        title={t('student.student.79')}
        visible={visible}
        width={400}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Block className="flex flex-justify-center">
          <div>
            {getSchemeText()} {t('student.student.80')}<br />
            {t('student.student.81')}

            <div className="text-center mt-3">
              <a href={getSchemeUrl()} rel="noreferrer">
                <button className="btn btn-success">
                  <div className="button-text">
                    {getSchemeText()} {t('student.student.82')}
                    <BiDownload className="ml-2" />
                  </div>
                </button>
              </a>
            </div>
          </div>
        </Block>
      </Modal>
    </>
  );
};

export default DownloadProgramModal;
